import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["endpoint"];
  protocol(event) {
    const defaults = {
      openai_compatible: "https://api.openai.com/v1",
      claude: "https://api.anthropic.com/v1",
      gemini: "https://generativelanguage.googleapis.com/v1beta",
    };
    if (Object.values(defaults).includes(this.endpointTarget.value) || !this.endpointTarget.value) {
      this.endpointTarget.value = defaults[event.target.value];
    }
  }
}
